import { api } from '../../lib/api';

export const ML_STATUSES = [
  { value: 'Draft', label: 'Draft', tone: 'neutral' },
  { value: 'InProgress', label: 'In progress', tone: 'warning' },
  { value: 'Finalized', label: 'Finalized', tone: 'success' },
  { value: 'Cancelled', label: 'Cancelled', tone: 'neutral' },
];

export const mlStatusMeta = (status) =>
  ML_STATUSES.find((s) => s.value === status) || { value: status, label: status, tone: 'neutral' };

function toQuery(params) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.append(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

export const marketlistApi = {
  list: (params = {}) => api.get(`/market-lists${toQuery(params)}`),
  get: (id) => api.get(`/market-lists/${id}`),
  getSuggestions: (params = {}) => api.get(`/market-lists/suggestions${toQuery(params)}`),
  create: (payload) => api.post('/market-lists', payload),
  update: (id, payload) => api.putWithId(`/market-lists/${id}`, id, payload),
  remove: (id) => api.del(`/market-lists/${id}`),
  startPurchasing: (id) => api.post(`/market-lists/${id}/start-purchasing`, {}),
  reopen: (id) => api.post(`/market-lists/${id}/reopen`, {}),
  finalize: (id, submit = true) => api.post(`/market-lists/${id}/finalize`, { submit }),
  cancel: (id, reason) => api.post(`/market-lists/${id}/cancel`, { reason: reason || null }),
};

export const marketListPath = (ml, suffix = '') =>
  `/market-list/${(ml?.number || ml?.id || '').toLowerCase()}${suffix}`;
